export default{
    Submit:"提交",
    Submitting:'提交中',
    Uploading:"上传中",
    Logging_in:"登录中",
    Loading:"加载中",
    No_more:"没有更多了",
    No_Data:"暂无相关数据",
    Pull_down:"下拉即可刷新...",
    Release_refresh:"释放即可刷新...",
    Please_login:"请登录",
    System_busy:"系统繁忙,请稍后重试",
    Login_succeeded:"登录成功",
    Recharging:"充币中",
    Purchasing:"购买中",
    Receiving:"领取中",
    Activating:"激活中",
    Extracting:"抽取中",
    Buying:"购买中",
    Opening:"开启中",
    Buy:"购买",
    login:"登录",
    first_login:"首次登录为设置密码，请牢记密码！",

    Not_connected:'未连接钱包',
    connect_wallet:"连接钱包",
    please_connect_wallet:"请连接钱包",
    Network_error:"网络连接错误，请更换网络",
    wait_confirm:"请等待链上确认",

    Ethereum_Main:"以太坊主网",
    Goerli_Test:"Goerli测试网络",
    Binance_Smart:"Binance智能链",
    BSC_test:"BSC测试网",

    enter_login_psw:"请输入登录密码",
    modified_success:'修改成功',
    twopsw_not_match:"两次输入新密码不一致",
    Change_password:"修改密码",
    Disconnect:"断开连接",
    enter_old_password:"请输入原密码",
    enter_new_password:"请输入新密码",
    enter_Confirm_Password:"请再次输入新密码",
    Confirm:'确认',
    Cancel:"取消",
    home:"首页",

    Recharge:"充币",
    Withdraw:'提币',
    Exchange:"兑换",
    transfer:"转让",
    Transfer_records:"转让记录",
    Transfer_in:"转入",
    Transfer_out:"转出至",
    wallet:"钱包",
    Draw_cards:"抽卡",
    Work_card:"职业卡",
    Chance_card:"机会卡",
    Explain:"说明",

    Working:"打工",
    trade_for:"转让记录",
    Unemployed:"待业中",
    In_office:"在职中",
    Financial_value:"财力值：",
    job_hunt:"上岗",
    cede:"转让",
    Congratulations_receiving:"恭喜成功领取",
    sure_job:"是否确认上岗？",
    sure_transfer:"是否确认转出？",
    Successful_job:"上岗成功",
    enter_transfer_address:"请输入转入地址",
    Transfer_successful:"转出成功",


    Currency:'币种',
    Enter_withdraw_num:'输入提币数量',
    handling_fee:"手续费：",
    amount:'数量：',
    quantity_not_range:"提币数量不在范围内",

    Enter_recharge_quantity:"输入充币数量",
    recharge_not_range:"充币数量不在范围内",
    recharge_base:"充币基数为",

    Wallet_address:"钱包地址",
    enter_Wallet_address:"请输入钱包地址",
    transfer_num:"数量",
    Please_enter_num:"请输入数量",
    transfer_balance:"余额：",
    
    Copied_successfully:"复制成功",
    copy_failed:"复制失败",
    authorize_first:"请先授权",

    Bank:"银行",
    enter_extraction:"请输入提取数量",
    enter_deposit:"请输入存入数量",
    Extraction_successful:"提取成功",
    Deposit_successful:"存入成功",
    Deposit:"存入",
    Extract:"提取",

    Internship:"实习",
    not_active:"待激活",
    Activated:"已激活",
    give:"转赠",
    invalid:"失效",
    activate:"激活",
    Value:'价值：',
    Transfer_to:"转出至：",
    day:"天",
    enter_give:"请输入转赠地址",
    sure_Activate_earning:"激活开始收益，确定激活吗？",
    Activation_successful:"激活成功",

    Received_successfully:"领取成功",
    choose_payment:"请选择支付方式",
    Payment_method:"支付方式",
    Entrepreneurship:"创业",
    Ended:"已结束",
    y_invalid:"已失效",
    Amount:"数量",
    lifespan:"有效期：",
    cycle:"周期",
    From_end:"距结束：",
    Total_value:"总投资：",
    Total_revenue:"总收益：",
    Receive:"领取",
    Price:"价格：",
    Yield_ratio:'收益比率：',
    Cycle1:"周期：",
    Activation_time:'激活时间：',
    End_time:'结束时间：',
    End_of_earnings:'结束收益：',


    Master_disciple:"公会",
    Today_earnings:"今日收益",
    TotalSY_performance:"累计收益",
    Team_performance:"公会级别",
    Team_TeamPer:"财商值",
    binding:"绑定",
    one_level:"一级",
    two_level:"二级",
    Copy:"复制",
    Invitation_link:"邀请链接：",
    enter_master:"请输入推荐人地址",
    Binding_successful:"绑定成功",
    details:"详情",

    Blind_box:"盲盒",
    occupation:'职业：',
    see:"查看",
    open:"开启",
    Open_box:"开启盲盒",
    sure_Open_box:"确认开启盲盒？",
    Congratulations_obtaining:"恭喜获得",
    Introduction:'介绍：',

    Recharge_Record:"充币记录",
    Recharge1:'充币：',
    Exchange_record:"兑换记录",
    Enter_exchange:"请输入兑换数量",
    Exchange_rate:"兑换比率",
    exchange_range:"兑换数量不在范围内",

    Chance_card_draw:"抽取机会卡",
    My_opportunity:"我的机会卡",
    Draw:'抽',
    Draw_cards1:"立即抽取",
    Card_Description:"机会卡说明：",
    profit:"收益：",
    drawing_expenses:"抽卡需消耗",
    Confirm_extraction:"，确认抽取？",

    Enter_buy_quantity:"输入购买数量",
    buy_not_range:"购买数量不在范围内",

    Withdraw_record:"提币记录",
    Withdrawal:"提币：",
    Reason_refusal:'拒绝理由：',

    Enter_transfer_Count:"输入转让数量",
    Transfer_address:"转入地址",
    transfer_range:"转让数量不在范围内",

    Withdraw1:"提币",
    Enter_withdrawal_quantity:"输入提币数量",
    Service_Charge:'手续费：',
    withdrawal_range:"提币数量不在范围内",

    reference:'推荐人：',
    Extract_work_card:"抽取职业卡",
    One_click_claim:"领取工资",

    My_Referrals:"我的推荐",
    detailed:"明细",
    Expiration_time:"失效时间：",
    Transfer_time:"转赠时间：",
    buy_time:"购买时间：",
    To_be_purchased:"待购买",
    Purchased:"已购买",
    Yield_rate:"收益率：",
    Total_amount:'总量：',
    Unit_Price:"单价：",
    Remaining_time:"有效期剩余时间：",
    invest_cycle:"投资周期：",

    Daily_decreasing:"每日递减：",
    Financial_IQ:"财商：",
}